import React, { ChangeEvent, FormEvent, useRef } from 'react';
import { Icon } from '../../../../../../base/components/Icon';
import { __t } from '../../../../../../base/utils/t';

import './styles.scss';

interface Props {
    value: string;
    changeHandler: (value: string) => void;
    submitHandler: () => void;
    clearSearch: () => void;
}

export const SearchBar = ({ value, changeHandler, submitHandler, clearSearch }: Props) => {
    const searchInputRef = useRef<HTMLInputElement>(null);

    const searchContainerClickHandler = () => {
        if (searchInputRef && searchInputRef.current) {
            searchInputRef.current.focus();
        }
    };

    const inputChangeHandler = (e: ChangeEvent<HTMLInputElement>) => {
        changeHandler(e.target.value.trimEnd());
    };

    const searchFormSubmitHandler = (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        submitHandler();
    };

    return (
        <div className='vacancy-table-searchbar' onClick={searchContainerClickHandler}>
            <Icon className='vacancy-table-searchbar__icon' icon='search' color='info' />
            <form className='vacancy-table-searchbar__form' onSubmit={searchFormSubmitHandler}>
                <input
                    type='text'
                    className='vacancy-table-searchbar__input'
                    value={value}
                    ref={searchInputRef}
                    placeholder={__t('Поиск по названию вакансии')}
                    onChange={inputChangeHandler}
                    autoComplete='off'
                />
                {value && (
                    <div className='vacancy-table-searchbar__clear-search' onClick={clearSearch}>
                        <Icon icon='xmark-regular' color='info' />
                    </div>
                )}
                <input type='submit' className='vacancy-table-searchbar__button' value={__t('Поиск')} />
            </form>
        </div>
    );
};
